module.exports = __webpack_public_path__ + "static/fonts/aui_iconfont.79f9d1e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/aui_iconfont.ttf
// module id = h3um
// module chunks = 1